import { CaseDocumentAdmin } from "pwapi";

import DocumentsTable from "../documentsTable/DocumentsTable";

const Documents = ({
  documents,
  setPreviewDocumentId,
}: {
  documents: CaseDocumentAdmin[];
  setPreviewDocumentId: Function;
}) => {
  return (
    <div className="panelContainer panelContainer--gap">
      <DocumentsTable
        documents={documents}
        setPreviewDocumentId={setPreviewDocumentId}
      />
    </div>
  );
};

export default Documents;
